import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

import FilterSelector from 'components/search_sidebar/filter_selector';

export default function TagsFilter({
  includeUntagged,
  selectedIds,
  tags,
  onSelectedChange,
  onToggleIncludeUntagged
}) {
  const [searchText, setSearchText] = useState('');

  const getSelectableTags = () => (
    tags.filter(tag => tag.label.toLowerCase().includes(searchText.toLowerCase()))
  );

  const isSelected = id => selectedIds.includes(id);
  const allSelected = () => getSelectableTags().every(tag => isSelected(tag.value)) && selectedIds.length > 0;
  const handleSearchChange = e => setSearchText(e.target.value);

  const handleSelect = (e) => {
    const value = e.target.value;

    if (isSelected(value)) {
      onSelectedChange(selectedIds.filter(id => id !== value));
    } else {
      onSelectedChange([...new Set([...selectedIds, value])]);
    }
  };

  const handleSelectAll = () => {
    onSelectedChange(allSelected() ? [] : getSelectableTags().map(tag => tag.value));
  };

  const renderTags = () => {
    const selectableTags = getSelectableTags();

    if (selectableTags.length < 1) {
      return <span className="text-muted" name="no-results">No matching tags found</span>;
    }

    return (
      <React.Fragment>
        <div className="select-all-checkbox">
          <Checkbox
            checked={allSelected()}
            name="select-all"
            value="select-all"
            onChange={handleSelectAll}
          >
            Select All
          </Checkbox>
        </div>
        {
          selectableTags.map((tag) => {
            return (
              <div className="filter-checkbox" key={tag.value}>
                <Checkbox
                  checked={isSelected(tag.value)}
                  inline={true}
                  name="select-tag"
                  value={tag.value}
                  onChange={handleSelect}
                >
                  {tag.label}
                </Checkbox>
              </div>
            );
          })
        }
        <Checkbox
          checked={includeUntagged}
          name="include-untagged"
          value="include-untagged"
          onChange={onToggleIncludeUntagged}
        >
          (No Tag)
        </Checkbox>        
      </React.Fragment>
    );
  };

  return (
    <FilterSelector
      searchText={searchText}
      searchTextPlaceHolder="Search tags"
      onSearchChange={handleSearchChange}
    >
      {renderTags()}
    </FilterSelector>
  );
}

TagsFilter.propTypes = {
  includeUntagged: PropTypes.bool.isRequired,
  selectedIds: PropTypes.array.isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  onSelectedChange: PropTypes.func.isRequired,
  onToggleIncludeUntagged: PropTypes.func.isRequired
};
